import arrowRight from '../assets/icons/arrow-right.svg';
import { JackInTheBox } from "react-awesome-reveal";
import type { MouseEvent } from 'react';
import type { ProjectItemProps } from '../store/types';

const ProjectItem = ({ portfolio, click, href }: ProjectItemProps) => {
    const onProjectLinkClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        click();
    };

    return (
        <div className="col-lg-4 col-10 mt-3">
            <JackInTheBox delay={100} fraction={0}>
                <a
                    href={href}
                    className="single-project-item project-trigger"
                    onClick={onProjectLinkClick}
                    aria-label={`Open ${portfolio.title} project details`}
                >
                    <div className="project-img">
                        <img
                            className="padding_img"
                            src={"/dataImages/" + portfolio?.logo}
                            alt={portfolio.title}
                            loading="lazy"
                        />
                    </div>

                    <div className="project-content">
                        <h6 className="text-white"> {portfolio.title}</h6>
                        <img src={arrowRight} className="arrow" alt="" aria-hidden="true" />
                    </div>
                </a>
            </JackInTheBox>
        </div>
    )
}
export default ProjectItem;
